import { Component, inject } from '@angular/core';
import { NotificationService } from '../../services/notification.service';
import { NgComponentOutlet } from '@angular/common';

@Component({
  selector: 'ui-notifications',
  imports: [NgComponentOutlet],
  templateUrl: './notifications.html',
})
export class Notifications {
  private notificationService = inject(NotificationService);
  notifications = this.notificationService.notifications;
}
